/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import classes from "./SideMenu.module.css";
import { Box, SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import { makeStyles } from "@mui/styles";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useResolvedPath,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
//*services
// import { signout } from "../../services/LoginService";
// import {getAdmin} from "../../services/FirebaseService";
//*Images
import sideMenuLogo from "../../Assets/Images/SideMenu/VJ LOGO V1 1.svg";
// import EventIcon from "../../assets/Images/SideMenu/Event.svg";
// import ProjectIcon from "../../assets/Images/SideMenu/Project.svg";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Logout from "../Icons/Logout";
import Event from "../Icons/Event";
import Project from "../Icons/Project";
import Sustenance from "../Icons/Sustenance";
import AllAllotments from "../Icons/AllAllotments";
import BenefitPlan from "../Icons/BenefitPlan";
import ChannelPartner from "../Icons/ChannelPartner";
import FastBooking from "../Icons/FastBooking";
import Leads from "../Icons/Leads";
import Payments from "../Icons/Payments";
import Settings from "../Icons/Settings";
import Token from "../Icons/Token";
import User from "../Icons/User";
import BackArrow from "../Icons/BackArrow";
import ArrowDropDownIcon from "../Icons/ArrowDropDownIcon";
import ArrowRightIcon from "../Icons/ArrowRightIcon";
import RocketIcon from "../Icons/RocketIcon";
import CPSelected from "../Icons/CPSelected";
import ProfileIcon from "../../Assets/Images/Common/ProfileIcon.svg";
import Hold from "../Icons/Hold";
//*mui
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
//*subComponent
import Button from "../../Subcomponents/Button";
import FilledRocketIcon from "../Icons/FilledRocketIcon";
// import { getCurrentUser } from "../../services/LoginService";

//Sub Menu Sustanance Details
import inventory from "../../Assets/Images/TabSustenanceDetailIcons/Inventory.svg";
import activeInventory from "../../Assets/Images/TabSustenanceDetailIcons/activeInventory.svg";
import siteVisitSubMenu from "../../Assets/Images/TabSustenanceDetailIcons/SiteVisit.svg";
import activeSiteVisitSubMenu from "../../Assets/Images/TabSustenanceDetailIcons/activeSiteVisit.svg";
import leadsSubMenu from "../../Assets/Images/TabSustenanceDetailIcons/Leads.svg";
import activeLeadsSubMenu from "../../Assets/Images/TabSustenanceDetailIcons/activeLeads.svg";
import cpAndSales from "../../Assets/Images/TabSustenanceDetailIcons/CP&Sales.svg";
import activeCpAndSales from "../../Assets/Images/TabSustenanceDetailIcons/activeCP&Sales.svg";
import directAllotment from "../../Assets/Images/TabSustenanceDetailIcons/DirectAllotment.svg";
import activeDirectAllotment from "../../Assets/Images/TabSustenanceDetailIcons/ActiveDirectAllotment.svg";
import cancelRequests from "../../Assets/Images/TabSustenanceDetailIcons/CancelRequests.svg";
import activeCancelRequest from "../../Assets/Images/TabSustenanceDetailIcons/activeCancelRequests.svg";
import changeUnitRequest from "../../Assets/Images/TabSustenanceDetailIcons/UnitChange.svg";
import activeChangeUnitRequest from "../../Assets/Images/TabSustenanceDetailIcons/activeChangeUnitRequest.svg";
import queue from "../../Assets/Images/TabSustenanceDetailIcons/Queue.svg";
import activeQueue from "../../Assets/Images/TabSustenanceDetailIcons/activeQueue.svg";
import TokenRefund from "../../Assets/Images/TabSustenanceDetailIcons/TokenRefund.svg";
import activeTokenRefund from "../../Assets/Images/TabSustenanceDetailIcons/activeTokenRefund.svg";
import EventToken from "../../Assets/Images/SideMenu/Token.svg";
import tokenSubMenu from "../../Assets/Images/SideMenu/TokenEventSubMenu.svg";
import activeSubMenuToken from "../../Assets/Images/SideMenu/activeSubMenuToken.svg";
import { insertLoginLogs, signOut } from "../../Services/LoginService";
import { errorTost } from "../../Services/Toast";
import store from "../../Redux Store/store";

//*users images
import CreateUserImage from "../../Assets/Images/Users/Create User.svg";
import CreateUserActiveImage from "../../Assets/Images/Users/Create User Active.svg";
import CreateRoleImage from "../../Assets/Images/Users/Create Role.svg";
import CreateRoleActiveImage from "../../Assets/Images/Users/Create Role Active.svg";
import AssignRoleImage from "../../Assets/Images/Users/Assign Role.svg";
import AssignRoleActiveImage from "../../Assets/Images/Users/Assign Role Active.svg";
import ProjectImage from "../../Assets/Images/Users/Project.svg";
import ProjectActiveImage from "../../Assets/Images/Users/Project Active.svg";
import { mainMenu } from "../../Services/StoredSessionData";
import axios from "axios";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getLaunchById } from "../../Services/Launch";
import CallIcon from "../Icons/CallIcon";import CallLogsMain from "../CallLogs/CallLogsMain";
import CallHistoryIcon from "../Icons/CallLogs";
import SalesManagerPersona from "../SalesManagerPersona/SalesManagerPersona";


const useStyles = makeStyles((theme) => ({
  menu_item: {
    marginBottom: "0.5rem !important",
    justifyContent: "space-evenly !important",
    "&:hover": {
      background: "#EFF8FF",
      borderRadius: "0px 20px 20px 0px !important",
    },
    // border:"none! important",
    // background:"#FFFFF !important"
  },
  icon: {
    // minWidth: "1.8rem !important",
    // marginRight: "1.7rem",
    // marginLeft: "1.3rem",
    minWidth: "2.8rem !important",
    marginRight: "1.3rem",
    marginLeft: "1.7rem",
  },
  menu: {
    margin: "0",
    "& span": {
      display: "inline-block",
      fontFamily: "Roboto-Regular",
      fontSize: "1.4rem",
      lineHeight: "2rem",
      color: "#667085",
      fontWeight: "400",
      marginLeft: "1rem",
    },
  },
  active: {
    background: "#EFF8FF !important",
    borderRadius: "0px 20px 20px 0px !important",
    color: "#FFFFFF",
    "& span": {
      color: "#1570EF",
      // background: "#1570EF"
    },
    "&:hover": {
      background: "#1570EF",
    },
  },
  subMenutitle: {
    fontFamily: "Roboto-Regular",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
  },
  user_avatar: {
    display: "inline-block !important",
    marginRight: "1.2rem !important",
    verticalAlign: "middle !important",
    width: "4rem !important",
    height: "4rem !important",
    "& svg": {
      transform: "translate(-50%, -50%)",
      top: "50%",
      left: "50%",
      position: "relative",
    },
  },
}));

function SideMenu({ props }) {
  let { projectId, eventID, eventId } = useParams();
  const classList = useStyles();
  const navigate = useNavigate();
  // const [eventId, setEventId] = useState("");
  const [activeSubMenu, setActiveSubMenu] = useState(false);
  const [activeSubSubMenu, setActiveSubSubMenu] = useState("Project");
  const [showSustenanceConfig, setShowSustenanceConfig] = useState(false);
  const [showEventConfig, setShowEventConfig] = useState(false);
  const [useCsv, setUseCsv] = useState(false);
  // const [activeSustenanceTabName, setActiveSustenanceConfig] =
  //   useState("inventory");
  const [activeEventConfigTabName, setActiveEventConfigTabName] = useState("Inventory");
  const [params, setParams] = useSearchParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const userTab = searchParams.get("userTab");
  const launchId = searchParams.get('launch')
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);
  const location = useLocation();
  const [index, setIndex] = useState(0);
  const [menuArray, setMenuArray] = useState([
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      name: "Dashboard",
      tabName: "dashboard",
      isVisible: true,
      path: "/home/Dashboard",
    },
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      // NEW — separate from "Dashboard" above. `name` must match a
      // "Sales Dashboard" key in a role's accessibleTabs for this to appear.
      name: "Sales Dashboard",
      tabName: "salesdashboard",
      isVisible: true,
      path: "/home/SalesDashboard",
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "Event",
      tabName: "Event",
      isVisible: true,
      path: "/home/Event",
    },
    {
      icon: <Project color={"#667085"} fill={"none"} />,
      activeIcon: <Project color={"#FFFF"} fill={"#1570EF"} />,
      name: "Project",
      tabName: "Project",
      isVisible: true,
      path: "/home/Projects",
    },
    {
      icon: <Hold color={"#667085"} fill={"none"} />,
      activeIcon: <Hold color={"#FFFF"} fill={"#1570EF"} />,
      name: "Hold/Release",
      tabName: "Hold",
      isVisible: true,
      path: "/home/Hold",
    },
    {
      icon: <CallIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "SmartFlo",
      tabName: "smartflo",
      isVisible: true,
      path: "/home/SmartFlo",
    },
     {
      icon: <CallIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "CallLogs",
      tabName: "calllogs",
      isVisible: true,
      path: "/home/callLogs",
    },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sales Manager Persona",
      tabName: "salesmanagerpersona",
      isVisible: true,
      path: "/home/salesManagerPersona",
    },
    {
      icon: <Sustenance color={"#667085"} fill={"none"} />,
      activeIcon: <Sustenance color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sustenance",
      tabName: "sustenance",
      isVisible: true,
      path: "/home/Sustenance",
    },
    {
      icon: <img src={siteVisitSubMenu} alt="Site Visit" />,
      activeIcon: <img src={activeSiteVisitSubMenu} alt="Site Visit" />,
      name: "Site Visit",
      label: "Site Visit Approval",
      tabName: "sitevisit",
      isVisible: true,
      path: "/home/SiteVisit",
    },
    {
      icon: <Token color={"#667085"} fill={"none"} />,
      activeIcon: <Token color={"#FFFF"} fill={"#1570EF"} />,
      name: "Token",
      tabName: "Token",
      isVisible: true,
      path: "/home/Token",
    },
    {
      icon: <ChannelPartner color={"#667085"} fill={"none"} />,
      activeIcon: <CPSelected />,
      name: "Partners",
      tabName: "channelpartner",
      isVisible: true,
      path: "/home/ChannelPartner",
    },
    {
      icon: <Payments color={"#667085"} fill={"none"} />,
      activeIcon: <Payments color={"#FFFF"} fill={"#1570EF"} />,
      name: "Payments",
      tabName: "payments",
      isVisible: true,
      path: "/home/Payments",
    },
    {
      icon: <Leads color={"#667085"} fill={"none"} />,
      activeIcon: <Leads color={"#FFFF"} fill={"#1570EF"} />,
      name: "Leads",
      tabName: "Leads",
      isVisible: true,
      path: "/home/Leads",
    },
    {
      icon: <FastBooking color={"#667085"} fill={"none"} />,
      activeIcon: <FastBooking color={"#1570EF"} fill={"#1570EF"} />,
      name: "FastBooking",
      tabName: "fastbooking",
      isVisible: true,
      path: "/home/FastBooking",
    },
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      name: "Benefit Plan",
      tabName: "benefitplan",
      isVisible: true,
      path: "/home/BenefitPlan",
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "CpPayout",
      label: "CP Payout",
      tabName: "cppayout",
      isVisible: true,
      path: "/home/CPPayout",
    },
    {
      icon: <AllAllotments color={"#667085"} />,
      activeIcon: <AllAllotments color={"#1570EF"} />,
      name: "All Allotments",
      tabName: "AllAllotments",
      isVisible: true,
      path: "/home/AllAllotments",
    },
    // {
    //   icon: <AllAllotments color={"#667085"} />,
    //   activeIcon: <AllAllotments color={"#1570EF"} />,
    //   name: "Farvision Allotments",
    //   tabName: "FarvisionAllotments",
    //   isVisible: true,
    //   path: "/home/FarvisionAllotments",
    // },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Users",
      tabName: "users",
      isVisible: true,
      path: "/home/users",
    },
    {
      icon: <Settings color={"#667085"} />,
      activeIcon: <Settings color={"#1570EF"} />,
      name: "Settings",
      tabName: "Settings",
      isVisible: true,
      path: "/home/Settings",
    },
    {
      icon: <Leads color={"#667085"} fill={"none"} />,
      activeIcon: <Leads color={"#FFFF"} fill={"#1570EF"} />,
      name: "Queue",
      tabName: "Queue",
      isVisible: true,
      path: "/home/Queue",
    },
    {
      icon: <FastBooking color={"#667085"} fill={"none"} />,
      activeIcon: <FastBooking color={"#1570EF"} fill={"#1570EF"} />,
      name: "Live Inventory",
      tabName: "liveInventory",
      isVisible: true,
      path: "/home/LiveInventory",
    },
    {
      icon: <img src={CreateRoleImage} alt="Hierarchy" />,
      activeIcon: <img src={CreateRoleActiveImage} alt="Hierarchy" />,
      name: "Hierarchy",
      tabName: "hierarchy",
      isVisible: true,
      path: "/home/Hierarchy"
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "Cancellation Bank Details",
      tabName: "CancellationBankDetails",
      isVisible: true,
      path: "/home/cancellation_bank_details_approval"
    },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "WorkTransfer",
      tabName: "worktransfer",
      isVisible: true,
      path: "/home/WorkTransfer",
    },
  ]);
  const [menuArrayCopy, setMenuArrayCopy] = useState([
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      name: "Dashboard",
      tabName: "dashboard",
      isVisible: true,
      path: "/home/Dashboard",
    },
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      // NEW — separate from "Dashboard" above. `name` must match a
      // "Sales Dashboard" key in a role's accessibleTabs for this to appear.
      name: "Sales Dashboard",
      tabName: "salesdashboard",
      isVisible: true,
      path: "/home/SalesDashboard",
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "Event",
      tabName: "Event",
      isVisible: true,
      path: "/home/Event",
    },
    {
      icon: <Project color={"#667085"} fill={"none"} />,
      activeIcon: <Project color={"#FFFF"} fill={"#1570EF"} />,
      name: "Project",
      tabName: "Project",
      isVisible: true,
      path: "/home/Projects",
    },
    {
      icon: <Hold color={"#667085"} fill={"none"} />,
      activeIcon: <Hold color={"#FFFF"} fill={"#1570EF"} />,
      name: "Hold/Release",
      tabName: "Hold",
      isVisible: true,
      path: "/home/Hold",
    },
      {
      icon: <CallIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "SmartFlo",
      tabName: "smartflo",
      isVisible: true,
      path: "/home/SmartFlo",
    },
     {
      icon: <CallIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "CallLogs",
      tabName: "calllogs",
      isVisible: true,
      path: "/home/callLogs",
    },
     {
      icon: <CallIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "CpSourcing",
      tabName: "CpSourcing",
      isVisible: true,
      path: "/home/cpSourcing",
    },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sales Manager Persona",
      tabName: "salesmanagerpersona",
      isVisible: true,
      path: "/home/salesManagerPersona",
    },
    {
      icon: <Sustenance color={"#667085"} fill={"none"} />,
      activeIcon: <Sustenance color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sustenance",
      tabName: "sustenance",
      isVisible: true,
      path: "/home/Sustenance",
    },
    {
      icon: <img src={siteVisitSubMenu} alt="Site Visit" />,
      activeIcon: <img src={activeSiteVisitSubMenu} alt="Site Visit" />,
      name: "Site Visit",
      label: "Site Visit Approval",
      tabName: "sitevisit",
      isVisible: true,
      path: "/home/SiteVisit",
    },
    {
      icon: <Token color={"#667085"} fill={"none"} />,
      activeIcon: <Token color={"#FFFF"} fill={"#1570EF"} />,
      name: "Token",
      tabName: "Token",
      isVisible: true,
      path: "/home/Token",
    },
    {
      icon: <ChannelPartner color={"#667085"} fill={"none"} />,
      activeIcon: <CPSelected />,
      name: "Partners",
      tabName: "channelpartner",
      isVisible: true,
      path: "/home/ChannelPartner",
    },
    {
      icon: <Payments color={"#667085"} fill={"none"} />,
      activeIcon: <Payments color={"#FFFF"} fill={"#1570EF"} />,
      name: "Payments",
      tabName: "payments",
      isVisible: true,
      path: "/home/Payments",
    },
    {
      icon: <Leads color={"#667085"} fill={"none"} />,
      activeIcon: <Leads color={"#FFFF"} fill={"#1570EF"} />,
      name: "Leads",
      tabName: "Leads",
      isVisible: true,
      path: "/home/Leads",
    },
    {
      icon: <FastBooking color={"#667085"} fill={"none"} />,
      activeIcon: <FastBooking color={"#1570EF"} fill={"#1570EF"} />,
      name: "FastBooking",
      tabName: "fastbooking",
      isVisible: true,
      path: "/home/FastBooking",
    },
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      name: "Benefit Plan",
      tabName: "benefitplan",
      isVisible: true,
      path: "/home/BenefitPlan",
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "CpPayout",
      label: "CP Payout",
      tabName: "cppayout",
      isVisible: true,
      path: "/home/CPPayout",
    },
    {
      icon: <AllAllotments color={"#667085"} />,
      activeIcon: <AllAllotments color={"#1570EF"} />,
      name: "All Allotments",
      tabName: "AllAllotments",
      isVisible: true,
      path: "/home/AllAllotments",
    },
    // {
    //   icon: <AllAllotments color={"#667085"} />,
    //   activeIcon: <AllAllotments color={"#1570EF"} />,
    //   name: "Farvision Allotments",
    //   tabName: "FarvisionAllotments",
    //   isVisible: true,
    //   path: "/home/FarvisionAllotments",
    // },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Users",
      tabName: "users",
      isVisible: true,
      path: "/home/users",
    },
    {
      icon: <Settings color={"#667085"} />,
      activeIcon: <Settings color={"#1570EF"} />,
      name: "Settings",
      tabName: "Settings",
      isVisible: true,
      path: "/home/Settings",
    },
    {
      icon: <Leads color={"#667085"} fill={"none"} />,
      activeIcon: <Leads color={"#FFFF"} fill={"#1570EF"} />,
      name: "Queue",
      tabName: "Queue",
      isVisible: true,
      path: "/home/Queue",
    },
    {
      icon: <FastBooking color={"#667085"} fill={"none"} />,
      activeIcon: <FastBooking color={"#1570EF"} fill={"#1570EF"} />,
      name: "Live Inventory",
      tabName: "liveInventory",
      isVisible: true,
      path: "/home/LiveInventory",
    },
    {
      icon: <img src={CreateRoleImage} alt="Hierarchy" />,
      activeIcon: <img src={CreateRoleActiveImage} alt="Hierarchy" />,
      name: "Hierarchy",
      tabName: "hierarchy",
      isVisible: true,
      path: "/home/Hierarchy"
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "Cancellation Bank Details",
      tabName: "CancellationBankDetails",
      isVisible: true,
      path: "/home/cancellation_bank_details_approval"
    },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "WorkTransfer",
      tabName: "worktransfer",
      isVisible: true,
      path: "/home/WorkTransfer",
    },
  ]);
  // **Mobile burger Menu for SubMenu's
  const [showSubMenuBurger, setShowSubMenuBurger] = useState(false);

  //*Event Config
  const [selectiveMenu, setSelectiveMenu] = useState([]);
  //*Sustenance
  const [sustenanceConfigArray, setSustenanceConfigArray] = useState([]);
  //*Event Details
  // const [eventsArray , seteventsArray]
  const eventsArray = [
    {
      icon: inventory,
      activeIcon: activeInventory,
      name: "Inventory",
      tabName: "eventinventory",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/Inventory`,
    },
    {
      icon: tokenSubMenu,
      activeIcon: activeSubMenuToken,
      name: "CP",
      tabName: "eventcp",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/CP`,
    },
    {
      icon: cpAndSales,
      activeIcon: activeCpAndSales,
      name: "Sales",
      tabName: "eventsales",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/Sales`,
    },
    {
      icon: tokenSubMenu,
      activeIcon: activeSubMenuToken,
      name: "Token Holders",
      tabName: "tokenholders",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/TokenHolders`,
    },
    {
      icon: siteVisitSubMenu,
      activeIcon: activeSiteVisitSubMenu,
      name: "Site Visit",
      tabName: "eventsitevisits",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/SiteVisit`,
    },
    {
      icon: directAllotment,
      activeIcon: activeDirectAllotment,
      name: "Direct Allotment",
      tabName: "eventdirectallotment",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/DirectAllotment`,
    },
    // {
    //   icon: queue,
    //   activeIcon: activeQueue,
    //   name: 'Queue',
    //   tabName: 'queue',
    //   isVisible: true,
    //   path: `/home/Event/Details/${eventID}/Queue`,
    // },
    // {
    //   icon: changeUnitRequest,
    //   activeIcon: activeChangeUnitRequest,
    //   name: 'Change Unit Requests',
    //   tabName: 'unitchangerequests',
    //   isVisible: true,
    //   path: `/home/Event/Details/${eventID}/UnitChangeRequests`,
    // },
    {
      icon: TokenRefund,
      activeIcon: activeTokenRefund,
      name: "Token Refund Requests",
      tabName: "tokenrefundrequests",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/TokenRefundRequests`,
    },
    {
      icon: TokenRefund,
      activeIcon: activeTokenRefund,
      name: "Bulk Token Refund",
      tabName: "bulktokenrefund",
      isVisible: true,
      path: `/home/Event/Details/${eventID}/BulkTokenRefund`,
    },
    // {
    //   icon: cancelRequests,
    //   activeIcon: activeCancelRequest,
    //   name: 'Cancel Unit Requests',
    //   tabName: 'eventcancelunitrequest',
    //   isVisible: true,
    //   path: `/home/Event/Details/${eventID}/CancelUnitRequests`,
    // },
  ];
  const userArray = [
    {
      name: "Add Details",
      isVisible: true,
      icon: CreateUserImage,
      activeIcon: CreateUserActiveImage,
    },
    {
      name: "Assign Role",
      isVisible: true,
      icon: AssignRoleImage,
      activeIcon: AssignRoleActiveImage,
    },
    {
      name: "Hierarchy",
      isVisible: true,
      icon: CreateRoleImage,
      activeIcon: CreateRoleActiveImage,
    },
    {
      name: "Assigned Projects",
      isVisible: true,
      icon: ProjectImage,
      activeIcon: ProjectActiveImage,
    },
  ];

  useEffect(() => {
    console.log(params.get("submenu"))
    if (launchId) {
      if (params.get("submenu") === 'Select Sales') {
        getLaunchById(launchId).then((resp) => {
          setUseCsv(resp.data[0].projectId.useCsvPrice)
        })
      }
    }
  }, [launchId, params.get("submenu")])

  useEffect(() => {
    let tempSideMenuArray = [];
    menuArrayCopy.forEach((el, index) => {
      //todo : remove if condition comment after hierarchy assign accessibleTabs
      if (Object.keys(loggedInUser?.roleId?.accessibleTabs).includes(el.name)) {
        // console.log('includes');
        tempSideMenuArray.push(el);
      }
    });
    console.log({ tempSideMenuArray })
    setMenuArray([...tempSideMenuArray]);
    if (tempSideMenuArray.length > 0) {
      let menu = {
        tabName: tempSideMenuArray[0].tabName,
        name: tempSideMenuArray[0].name,
        path: tempSideMenuArray[0].path,
      };
      console.log(activeMenu);
      if (activeMenu === tempSideMenuArray[0].name) {
        navigate(tempSideMenuArray[0].path);
      }
    }
  }, [loggedInUser]);

  // ??MobileMenu check to show subMenu
  useEffect(() => {
    console.log(location.pathname.includes("CreateLaunch"));
    console.log(location.pathname);
    if (location.pathname.includes("/home/Event/Details") || location.pathname.includes("/home/Event/ConfigureEvent") || location.pathname.includes("/home/Sustenance/Details/") || location.pathname.includes("/home/users/createUser")) {
      setShowSubMenuBurger(true);
    } else {
      setShowSubMenuBurger(false);
    }
  }, [location])

  useEffect(() => {
    console.log("user")
  }, [loggedInUser])
  // useEffect(() => {
  //   console.log("--->tempSubArray----->")
  //  if (sustenanceConfigArray.filter((e) => {
  //      return e.path.includes('undefined');}).length > 0) {
  //    console.log("undefined-passed")
  //    if (sustenanceConfigArray.length === 0) {
  //      let tempSubSideMenuArray = [];
  //      console.log("if",projectId);
  //      sustenanceConfigArray.forEach((el, index) => {
  //        console.log("Sustenance-if" , Object.keys(loggedInUser?.roleId?.accessibleTabs?.Sustenance).includes(el.name));
  //        if (Object.keys(loggedInUser?.roleId?.accessibleTabs?.Sustenance).includes(el.name)) {
  //          if (loggedInUser?.roleId?.accessibleTabs?.Sustenance?.[el.name]?.isAccessible) {
  //            console.log("el",el);
  //            tempSubSideMenuArray.push(el);
  //          }
  //        }
  //      });
  //      console.log("---->",[tempSubSideMenuArray])
  //      setSustenanceConfigArray([...tempSubSideMenuArray]);
  //      if (tempSubSideMenuArray.length === 0) {
  //        let menu = {
  //         // tabName: tempSubSideMenuArray[0].tabName,
  //         //  name: tempSubSideMenuArray[0].name,
  //         //  path: tempSubSideMenuArray[0].path,
  //        };
  //        console.log('activeMenu', activeMenu);
  //        if (activeMenu === tempSubSideMenuArray[0].name) {
  //          navigate(tempSubSideMenuArray[0].path);
  //        }
  //      }
  //    }
  //  }
  // }, [sustenanceConfigArray]);

  useEffect(() => {
    checkParams();
  }, [params]);
  useEffect(() => {
    // setEventId("5435");
    // // setEventId(id);
    console.log("CHANGED");
    console.log(eventId);
    setSelectiveMenu([
      {
        arrowClose: <ArrowDropDownIcon />,
        arrowOpen: <ArrowRightIcon />,
        icon: <RocketIcon color={"#667085"} fill={"#667085"} />,
        activeIcon: <FilledRocketIcon />,
        name: "Create a launch",
        path: `/home/Event/ConfigureEvent/${eventId}/CreateLaunch`,
        showDropDown: false,
        SubList: [
          {
            name: "Add Launch Title",
            selected: false,
          },
          {
            name: "Select Project",
            selected: false,
          },
          {
            name: "Select Sales",
            selected: false,
          },
          {
            name: "Select Cp",
            selected: false,
          },
          {
            name: "Select Inventory",
            selected: false,
          },
          {
            name: "Select PriceList",
            selected: false,
          },
          {
            name: "Select Payment Plans",
            selected: false,
          },
          {
            name: "Preview Inventory",
            selected: false,
          },
          {
            name: "Preselect Config",
            selected: false
          }
        ],
      },
      {
        arrowClose: <ArrowDropDownIcon />,
        arrowOpen: <ArrowRightIcon />,
        icon: <Token color={"#667085"} fill={"none"} />,
        activeIcon: <Token color={"#FFFF"} fill={"#1570EF"} />,
        name: "Select Token",
        path: `/home/Event/ConfigureEvent/${eventId}/SelectTokens`,
        showDropDown: false,
        SubList: [
          {
            name: "Repeated Launch",
            selected: false,
          },
          {
            name: "Select Token",
            selected: false,
          },
          {
            name: "Select Prerequisite",
            selected: false,
          },
          {
            name: "Schedule Token",
            selected: false,
          },
          {
            name: "Tag Launch",
            selected: false,
          },
        ],
      },
      {
        arrowClose: <ArrowDropDownIcon />,
        arrowOpen: <ArrowRightIcon />,
        icon: <Event color={"#667085"} fill={"none"} />,
        activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
        name: "Attendance Configuration",
        path: `/home/Event/ConfigureEvent/${eventId}/attendanceConfiguration`,
        showDropDown: false,
        SubList: [
          {
            name: "Select Tokens For Attendance",
            selected: false,
          },
          {
            name: "Arrange Token",
            selected: false,
          },
          {
            name: "Select Queue Order",
            selected: false,
          },
          {
            name: "Select Cp/Sales",
            selected: false,
          },
          {
            name: "Change Priority",
            selected: false,
          },
        ],
      },
      {
        arrowClose: <ArrowDropDownIcon />,
        arrowOpen: <ArrowRightIcon />,
        icon: <Event color={"#667085"} fill={"none"} />,
        activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
        name: "Settings",
        path: `/home/Event/ConfigureEvent/${eventId}/Settings`,
        showDropDown: false,
        SubList: [
          {
            name: "Live Event Config",
            selected: false,
          },
          {
            name: "Live Inventory Display Config",
            selected: false,
          },
          {
            name: "Payment Config",
            selected: false,
          },
          {
            name: "Preselect Config",
            selected: false,
          },
          {
            name: "Site Visit Config",
            selected: false,
          },
        ],
      },
    ]);
  }, [eventId]);

  useEffect(() => {
    console.log("Project-Array");
    console.log("projectId", projectId);

    setSustenanceConfigArray([
      {
        icon: inventory,
        activeIcon: activeInventory,
        name: "Inventory",
        tabName: "inventory",
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/Inventory`,
      },
      {
        icon: tokenSubMenu,
        activeIcon: activeSubMenuToken,
        name: "CP",
        tabName: "cp",
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/Cp`,
      },

      {
        icon: cpAndSales,
        activeIcon: activeCpAndSales,
        name: "Sales",
        tabName: "sales",
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/Sales`,
      },
      {
        icon: leadsSubMenu,
        activeIcon: activeLeadsSubMenu,
        name: "Leads",
        tabName: "sustenancelead",
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/Lead`,
      },
      {
        icon: siteVisitSubMenu,
        activeIcon: activeSiteVisitSubMenu,
        name: "Site Visit",
        tabName: "sitevisit",
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/SiteVisit`,
      },

      {
        icon: directAllotment,
        activeIcon: activeDirectAllotment,
        name: "Direct Allotment",
        tabName: "directallotment",
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/DirectAllotment`,
      },
      {
        icon: changeUnitRequest,
        activeIcon: activeChangeUnitRequest,
        name: 'Price List',
        tabName: 'pricelist',
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/PriceList`,
      },
      {
        icon: cancelRequests,
        activeIcon: activeCancelRequest,
        name: 'Payment Plans',
        tabName: 'paymentplans',
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/PaymentPlans`,
      },
      {
        icon: queue,
        activeIcon: activeQueue,
        name: 'Collaterals',
        tabName: 'collaterals',
        isVisible: true,
        path: `/home/Sustenance/Details/${projectId}/Collaterals`,
      },
    ]);
  }, [projectId]);

  useEffect(() => {
    setSelectiveMenu((pre) => {
      pre = pre.map((m) => ({
        ...m,
        showDropDown: false,
      }));
      if (location.pathname.includes("CreateLaunch")) {
        pre[0].showDropDown = true;
      } else if (location.pathname.includes("SelectTokens")) {
        pre[1].showDropDown = true;
      } else if (location.pathname.includes("attendanceConfiguration")) {
        pre[2].showDropDown = true;
      } else if (location.pathname.includes("Settings")) {
        pre[3].showDropDown = true;
      }
      return [...pre];
    });
  }, [activeSubSubMenu]);
  useEffect(() => {
    // console.log(window.location.href);
    if (window.location.href.includes(`home/Event/ConfigureEvent`)) {
      setShowEventConfig(false);
      setShowSustenanceConfig(false);
      setActiveSubMenu(true);
    } else if (window.location.href.includes("/home/Sustenance/Details")) {
      setShowSustenanceConfig(true);
      setActiveSubMenu(false);
      setShowEventConfig(false);
    } else if (window.location.href.includes("/home/Event/Details")) {

      if (location.pathname.includes("DirectAllotment")) {
        setActiveEventConfigTabName("eventdirectallotment");
      } else if (location.pathname.includes("CP")) {
        setActiveEventConfigTabName("eventcp");
      } else if (location.pathname.includes("TokenHolders")) {
        setActiveEventConfigTabName("tokenholders");
      } else if (location.pathname.includes("SiteVisit")) {
        setActiveEventConfigTabName("eventsitevisits");
      } else if (location.pathname.includes("Queue")) {
        setActiveEventConfigTabName("queue");
      } else if (location.pathname.includes("UnitChangeRequests")) {
        setActiveEventConfigTabName("unitchangerequests");
      } else if (location.pathname.includes("TokenRefundRequests")) {
        setActiveEventConfigTabName("tokenrefundrequests");
      } else if (location.pathname.includes("CancelUnitRequests")) {
        setActiveEventConfigTabName("eventcancelunitrequest");
      } else if (location.pathname.includes("Inventory")) {
        setActiveEventConfigTabName("eventinventory");
      } else if (location.pathname.includes("Sales")) {
        setActiveEventConfigTabName("eventsales");
      } else if (location.pathname.includes("BulkTokenRefund")) {
        setActiveEventConfigTabName("bulktokenrefund");
      }
      setShowEventConfig(true);
      setShowSustenanceConfig(false);
      setActiveSubMenu(false);
    } else {
      setShowSustenanceConfig(false);
      setActiveSubMenu(false);
      setShowEventConfig(false);
    }
  }, [activeMenu]);

  function logoutUser() {
    presentLoader()
    signOut()
      .then(({ err }) => {
        if (err) {
          dismissLoader()
          errorTost(err);
        } else {
          let logObj = {
            userId: JSON.parse(localStorage.getItem('user')).userId,
            action: "logout",
            latitude: '',
            longitude: '',
            ipv4: ''
          }
          axios.get(process.env.REACT_APP_IPIFY_URL).then(async (resp) => {
            logObj.ipv4 = resp.data
            const getGeoLocationResponse = await getGeoLocation();
            if (getGeoLocationResponse.success) {
              logObj.latitude = getGeoLocationResponse.data.latitude
              logObj.longitude = getGeoLocationResponse.data.longitude
            }
            insertLoginLogs(logObj).then((insertRes) => {
              dismissLoader()
              store.dispatch(action.authLogout());
              navigate("/");
            }).catch((err) => {
              dismissLoader()
              store.dispatch(action.authLogout());
              navigate("/");
            })
          }).catch((err) => {
            dismissLoader()
            store.dispatch(action.authLogout());
            navigate("/");
          })
        }
      })
      .catch((error) => {
        dismissLoader()
        errorTost(error);
      });
  }
  //  console.log("menu",activeMenu)
  function getGeoLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
      } else {
        resolve({ success: false, message: "Geolocation is not supported by this browser." });
      }

      function geoSuccess(position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        resolve({ success: true, data: { latitude, longitude } });
      }
      function geoError() {
        resolve({ success: false, message: "Geocoder failed." });
      }
    })
  }

  function checkParams() {
    console.log(params.get("submenu"));
    setActiveSubSubMenu(params.get("submenu"));
  }
  return (<>
    {(window.innerWidth > 820 || showSubMenuBurger) && (
      <div className={classes.wrapper}>
        <div className={classes.app_info}>
          <div className={classes.app_logo}>
            <img
              src={sideMenuLogo}
              alt="logo"
              className={classes.sideMenuLogo}
              style={{ width: "14rem" }}
            />
          </div>
        </div>
        {window.innerWidth > 820 &&
          activeSubMenu === false &&
          showSustenanceConfig === false &&
          showEventConfig === false &&
          !window.location.href.includes("home/users/createUser") && (
            <div className={classes.menu_array}>
              <List>
                {menuArray.map(
                  (menu, index) =>
                    menu.isVisible && (
                      <div
                        to={menu.path}
                        key={`MenuArray_${index}`}
                        onKeyDown={(e) => {
                          if (e.keyCode === 32 || e.keyCode === 13) {
                            navigate(menu.path);
                          }
                        }}
                        onClick={(e) => {
                          navigate(menu.path);
                          sessionStorage.clear();
                        }}
                      >
                        <ListItem
                          button
                          key={menu.tabName}
                          className={classList.menu_item}
                          selected={activeMenu === menu.tabName.toLowerCase()}
                          classes={{ selected: classList.active }}
                        >
                          <ListItemIcon className={classList.icon}>
                            {activeMenu === menu.tabName.toLowerCase()
                              ? menu.activeIcon
                              : menu.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={menu.label || menu.name}
                            className={classList.menu}
                          />
                        </ListItem>
                      </div>
                    )
                )}
              </List>
            </div>
          )}
        {/* EventConfig */}
        {(activeSubMenu) && (
          <div className={classes.wrapperSubMenu}>
            <div>
              <Button
                iconPosition={"left"}
                btnName={"Go to Dashboard"}
                btnIcon={<BackArrow />}
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#667085",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                }}
                clicked={() => {
                  if (activeMenu && activeSubSubMenu) {
                    navigate(`/home/Event/ConfigureEvent/${eventId}`);
                    setSelectiveMenu((pre) => {
                      pre = pre.map((m) => ({
                        ...m,
                        showDropDown: false,
                      }));
                      return [...pre];
                    });
                  } else {
                    navigate("/home/Event");
                    setActiveSubMenu(false);
                    setShowSustenanceConfig(false);
                  }
                }}
              />
            </div>

            {selectiveMenu.map((menu, index) => (
              <div className={classes.wrapperSubMenuBlock}>
                <div style={{ width: "100%" }}>
                  <div
                    className={
                      selectiveMenu[index].showDropDown
                        ? classes.activeSubMenu
                        : classes.subMenuBlock
                    }
                  >
                    {menu.showDropDown ? (
                      <div
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          // setSelectiveMenu((pre) => {
                          //   pre[index].showDropDown = false;
                          //   return [...pre];
                          // });
                        }}
                      >
                        {menu.arrowOpen}
                      </div>
                    ) : (
                      <div
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(
                            menu.name === "Select Token"
                              ? menu.path + "?submenu=" + menu.SubList[1].name
                              : menu.path + "?submenu=" + menu.SubList[0].name
                          );
                          setSelectiveMenu((pre) => {
                            pre = pre.map((m) => ({
                              ...m,
                              showDropDown: false,
                            }));
                            pre[index].showDropDown = true;
                            return [...pre];
                          });
                        }}
                      >
                        {menu.arrowClose}
                      </div>
                    )}
                    {selectiveMenu[index].showDropDown ? (
                      <div style={{ display: "flex" }}>{menu.activeIcon}</div>
                    ) : (
                      <div>{menu.icon}</div>
                    )}

                    <div>{menu.name}</div>
                  </div>
                  {menu.showDropDown && (
                    <div className={classes.subMenuBlockTitle}>
                      {menu.SubList.filter((e) => {
                        if (useCsv && menu.name === 'Create a launch') {
                          return e.name !== 'Select PriceList' && e.name !== 'Select Payment Plans'
                        } else {
                          return e
                        }
                      }).map((el, SubIndex) => (
                        <div
                          className={
                            activeSubSubMenu === el.name
                              ? classes.activeSubSubMenu
                              : classes.wrapperSubSubMenu
                          }
                        >
                          <div
                            className={classes.subMenuBlockTitleName}
                            onClick={() => {
                              setSelectiveMenu((pre) => {
                                pre = pre.map((m) => ({
                                  ...m,
                                  showDropDown: false,
                                }));
                                pre[index].showDropDown = true;
                                return [...pre];
                              });
                              navigate(menu.path + "?submenu=" + el.name);
                              checkParams();
                            }}
                          >
                            {el.name}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        {/* Sustenance and event config */}
        {showSustenanceConfig && (
          <div className={classes.wrapperSubMenu}>
            <div>
              <Button
                iconPosition={"left"}
                btnName={"Go to Sustenance"}
                btnIcon={<BackArrow />}
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#667085",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                }}
                clicked={() => {
                  navigate("/home/Sustenance");
                  setActiveSubMenu(false);
                  setShowSustenanceConfig(false);
                }}
              />
            </div>

            <div className={classes.menu_array}>
              <List>
                {sustenanceConfigArray?.filter((f) => loggedInUser?.roleId?.accessibleTabs?.Sustenance[f?.name]?.isAccessible).map(
                  (menu, index) =>
                    menu.isVisible && (
                      <div
                        to={menu.path}
                        key={`MenuArray_${index}`}
                        onKeyDown={(e) => {
                          if (e.keyCode === 32 || e.keyCode === 13) {
                            navigate(menu.path);
                          }
                        }}
                        onClick={(e) => {
                          navigate(menu.path);
                          console.log("menu.path", menu.path);
                          sessionStorage.clear();
                          // console.log(activeSustenanceTabName);
                          // // console.log("menu-TabName" , menu.tabName)
                          // setActiveSustenanceConfig(menu.tabName);
                        }}
                      >
                        <ListItem
                          button
                          key={menu.tabName}
                          className={classList.menu_item}
                          selected={
                            activeMenu === menu.tabName.toLowerCase()
                          }
                          classes={{ selected: classList.active }}
                        >
                          <ListItemIcon className={classList.icon}>
                            {activeMenu === menu.tabName.toLowerCase() ? (
                              <img src={menu.activeIcon} alt={"icons"} />
                            ) : (
                              <img src={menu.icon} alt={"activeTabIcons"} />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            primary={menu.name}
                            className={classList.menu}
                          />
                        </ListItem>
                      </div>
                    )
                )}
              </List>
            </div>
          </div>
        )}
        {/* {View Details (Event)} */}
        {(showEventConfig) && (
          <div className={classes.wrapperSubMenu}>
            <div>
              <Button
                iconPosition={"left"}
                btnName={"Go to Events"}
                btnIcon={<BackArrow />}
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#667085",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                }}
                clicked={() => {
                  navigate("/home/Event");
                  setActiveSubMenu(false);
                  setShowSustenanceConfig(false);
                }}
              />
            </div>
            <div className={classes.menu_array}>
              <List>
                {eventsArray?.filter((f) => loggedInUser?.roleId?.accessibleTabs?.Event["View Details"]?.[f?.name]?.isAccessible)
                  .filter((f) => f.tabName === "eventdirectallotment" ? JSON.parse(sessionStorage.getItem("isEventLive")) ? true : false : true)
                  .map(
                    (menu, index) =>
                      menu.isVisible && (
                        <div
                          to={menu.path}
                          key={`MenuArray_${index}`}
                          onKeyDown={(e) => {
                            if (e.keyCode === 32 || e.keyCode === 13) {
                              navigate(menu.path);
                            }
                          }}
                          onClick={(e) => {
                            navigate(menu.path);
                            // console.log(activeEventConfigTabName);
                            // console.log("menu-TabName" , menu.tabName)
                            setActiveEventConfigTabName(menu.tabName);
                          }}
                        >
                          <ListItem
                            button
                            key={menu.tabName}
                            className={classList.menu_item}
                            selected={
                              activeEventConfigTabName ===
                              menu.tabName.toLowerCase()
                            }
                            classes={{ selected: classList.active }}
                          >
                            <ListItemIcon className={classList.icon}>
                              {activeMenu === menu.tabName.toLowerCase() ? (
                                <img src={menu.activeIcon} alt={"icons"} />
                              ) : (
                                <img src={menu.icon} alt={"activeTabIcons"} />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary={menu.name}
                              className={classList.menu}
                            />
                          </ListItem>
                        </div>
                      )
                  )}
              </List>
            </div>
          </div>
        )}
        {window.location.href.includes("home/users/createUser") && (
          <div className={classes.wrapperSubMenu}>
            <div>
              <Button
                iconPosition={"left"}
                btnName={"Go to Users"}
                btnIcon={<BackArrow />}
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#667085",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                }}
                clicked={() => {
                  navigate("/home/users");
                }}
              />
            </div>
            <div className={classes.menu_array}>
              <List>
                {userArray.map(
                  (menu, index) =>
                    menu.isVisible && (
                      <div
                        // to={menu.path}
                        key={`MenuArray_${index}`}
                        onKeyDown={(e) => {
                          if (e.keyCode === 32 || e.keyCode === 13) {
                            navigate(menu.path);
                          }
                        }}
                        onClick={(e) => {
                          // menu.onClick();
                          searchParams.set("userTab", menu.name);
                          setSearchParams(searchParams);
                        }}
                      >
                        <ListItem
                          button
                          key={menu.tabName}
                          className={classList.menu_item}
                          selected={
                            // activeEventConfigTabName === menu.tabName.toLowerCase()
                            // true
                            userTab === menu.name
                          }
                          classes={{ selected: classList.active }}
                        >
                          <ListItemIcon className={classList.icon}>
                            {userTab === menu.name ? (
                              <img src={menu.activeIcon} alt={"icons"} />
                            ) : (
                              <img src={menu.icon} alt={"activeTabIcons"} />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            primary={menu.name}
                            className={classList.menu}
                          />
                        </ListItem>
                      </div>
                    )
                )}
              </List>
            </div>
          </div>
        )}
        <Divider
          sx={{
            width: "100%",
            borderColor: "#DADCE0",
          }}
        />
        <Box className={classes.user_profile} >
          {loggedInUser.profileImgUrl ? (
            <img
              src={
                process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                loggedInUser?.profileImgUrl +
                `?${Date.now()}`
              }
              alt=""
              id="profilePhoto"
              className={classList.user_avatar}
            />
          ) : (
            // <AccountCircleOutlinedIcon
            //   sx={{
            //     fontSize: "3rem",
            //     color: "#1D2939",

            //     marginRight: "1.2rem",
            //   }}
            // />
            <img
              src={ProfileIcon}
              alt=""
              id="profilePhoto"
              className={classList.user_avatar}
            />
          )}

          <div
            className={classes.user_info}

          >
            {loggedInUser && (
              <>
                <Box className={classes.user_name} title={loggedInUser.name} style={{ cursor: "pointer" }} onClick={() => { navigate("/home/Profile") }}>
                  {loggedInUser.name}
                </Box>
                <div
                  className={classes.user_email}
                  title={loggedInUser?.email}
                >
                  {loggedInUser?.email}
                </div>
              </>
            )}
          </div>
          <div
            className={classes.logout}
            tabIndex={0}
            onClick={logoutUser}
            title="Logout"
            onKeyDown={(e) => {
              if (e.keyCode === 32 || e.keyCode === 13) {
                logoutUser();
              }
            }}
          >
            {<Logout />}
          </div>
        </Box>
      </div> // **Mobile Menu
    )}

    {/* { window.innerWidth < 820&&(
        <Box
        sx={{
          borderRadius: "1.3rem 1.3rem 0 0",
          bgcolor: "#fff",
          boxShadow: "0px 0px 15px rgb(73 83 211 / 5%)",
          height: "10%",
          // display: keyboardOpen ? 'none' : ''
        }}
      >
      
                      <Tabs
                      sx={{
                        width: "100%",
                        height: "100%",
                        justifyContent: "center",
                      }}
                      size="lg"
                      aria-label="Bottom Navigation"
                      value={index}
                      onChange={(event, value) => setIndex(value)}
                    >
                      <TabList variant="plain" sx={{ padding: "0" }}>
                      {menuArray.map((menu, index) =>
                    (menu.name==='Event'||menu.name==='Project'||menu.name==='Leads'||menu.name==='FastBooking') && (
                        <Tab
                          orientation="vertical"
                          sx={{
                            color: activeMenu  === menu.tabName.toLowerCase() ? "#28303F" : "#98A2B3",
                            "&:hover": {
                              color: "#98A2B3",
                            },
                            gap:'1rem'
                          }}
                          className={classes.mobile_menu}
                          onClick={(e) => {
                            navigate(menu.path);
                          }}
                        >
                          <ListItemIcon className={classList.icon}>
                            {activeMenu === menu.tabName.toLowerCase()
                              ? menu.activeIcon
                              : menu.icon}
                          </ListItemIcon>
                          {menu.name}
                        </Tab>
                          ))}
                          <Tab
                          orientation="vertical"
                          sx={{
                            color: activeMenu==='mobileSubMenu' ? "#28303F" : "#98A2B3",
                            "&:hover": {
                              color: "#98A2B3",

                            },
                            gap:'0.5rem'
                          }}
                          className={classes.mobile_menu}
                          onClick={(e) => {
                           navigate('/home/MobileSubMenu')
                          }}
                        >
                          <ListItemIcon className={classList.icon}>
                            { activeMenu==='mobileSubMenu'
                              ? <Settings color={"#1570EF"} />
                              : <Settings color={"#667085"} />}
                          </ListItemIcon>
                        Settings
                        </Tab>
                      </TabList>
                    </Tabs>
                  
       
      </Box>
       )  
  } */}
  </>
  )


}
export default SideMenu;
